import React from "react";
import IntelligenceWorkspaceShell from "./IntelligenceWorkspaceShell";

export default function ExecutiveSummary({ children }) {
  return (
    <IntelligenceWorkspaceShell
      workspaceKey="overview"
      eyebrow="Organisation intelligence"
      title="Executive Summary"
      description="What needs leadership attention now."
    >
      {children}
    </IntelligenceWorkspaceShell>
  );
}
